import { Store } from "vuex";
import NOTIFICATION_MODULE from "./notification.name";
import { notificationStore } from "./notification.store";

export default (context: { store: Store<null>; http: any }): void => {
  const { store } = context;

  store.registerModule(NOTIFICATION_MODULE, notificationStore);
};
